import { render } from "./noteDialog.vue?vue&type=template&id=c77ef85c&scoped=true"
import script from "./noteDialog.vue?vue&type=script&lang=js"
export * from "./noteDialog.vue?vue&type=script&lang=js"

import "./noteDialog.vue?vue&type=style&index=0&id=c77ef85c&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c77ef85c"]])

export default __exports__